import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import SignIn from "../../components/authentication/signin/signin";

const mapDispatchToProps = dispatch => ({
    get refreshSession() {
        return async () => {
            dispatch({
                type: `REFRESH_SESSION`
            });
        }
    },
    get loggedIn() {
        return async (role, isNewUser, decedentId, decedentError) => {
            dispatch({
                type: `LOGIN`,
                payload: {
                    isLoggedIn: true,
                    role,
                    isNewUser,
                    decedentId,
                    decedentError
                }
            });
        };
    }
});

export default connect(null, mapDispatchToProps)(withRouter(SignIn));
